import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { ShinyButton } from "@/components/ui/shiny-button";
import { Menu, X } from "lucide-react";

export default function Navbar({ onDemoClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Funcionalidades", href: "#funcionalidades" },
    { label: "Como Funciona", href: "#como-funciona" },
    { label: "Segurança", href: "#seguranca" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "py-3 bg-[#050B14]/80 backdrop-blur-xl border-b border-white/[0.06]"
          : "py-5 bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <a href="#" data-testid="navbar-logo" className="flex items-center group">
          <img src="/automialogo.png" alt="Automia" className="h-14 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-1 px-2 py-1.5 rounded-full glass-card">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`navbar-link-${l.href.replace("#", "")}`}
              className="px-4 py-2 text-sm text-slate-300 hover:text-white rounded-full hover:bg-white/5 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <ShinyButton
            data-testid="navbar-cta-demo"
            onClick={onDemoClick}
            className="inline-flex items-center justify-center px-5 h-10 font-medium border-0 text-white"
            style={{
              background: "linear-gradient(180deg, #3B82F6 0%, #2563EB 100%)",
              boxShadow: "0 1px 0 rgba(255,255,255,0.2) inset, 0 -1px 0 rgba(0,0,0,0.2) inset, 0 12px 32px -8px rgba(37,99,235,0.6), 0 0 0 1px rgba(59,130,246,0.5)",
            }}
          >
            Experimente 7 dias grátis
          </ShinyButton>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setMobileOpen((v) => !v)}
          className="lg:hidden h-10 w-10 rounded-lg flex items-center justify-center glass-card text-white"
          aria-label="Menu"
        >
          {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {mobileOpen && (
        <div data-testid="navbar-mobile-menu" className="lg:hidden mt-3 mx-6 glass-card rounded-2xl p-3">
          <div className="flex flex-col">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm text-slate-200 hover:bg-white/5 rounded-lg"
              >
                {l.label}
              </a>
            ))}
            <Button
              data-testid="navbar-mobile-cta"
              onClick={() => {
                setMobileOpen(false);
                onDemoClick();
              }}
              className="btn-primary-glow text-white border-0 rounded-full mt-2 h-11"
            >
              Experimente 7 dias grátis
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
